import { FaFacebookF, FaPinterestP, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

export const socialIcons = [
  { icon: <FaFacebookF />, name: 'Facebook' },
  { icon: <FaXTwitter />, name: 'Twitter' },
  { icon: <FaPinterestP />, name: 'Pinterest' },
  { icon: <FaYoutube />, name: 'Youtube' },
];

export const paragraph = `Take your health and body to the next level with our comprehensive
  program designed to help you reach your fitness goals.`;
